var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignUpSlient1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 346.326,
    height: 183.55,
    viewBox: "0 0 346.326 183.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22714",
    "data-name": "Group 22714",
    transform: "translate(18979.287 23840.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12204",
    "data-name": "Path 12204",
    d: "M355.242,781.04c-95.644,0-173.167,4.154-173.167,9.279S259.6,799.6,355.242,799.6,528.4,795.445,528.4,790.319s-77.528-9.279-173.159-9.279",
    transform: "translate(-19161.361 -24456.414)",
    fill: "#d6daf9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12054",
    "data-name": "Path 12054",
    d: "M924.221,1040.159H868.005a3.875,3.875,0,0,1,3.769-2.978c.088,0,.177,0,.264.01a5.957,5.957,0,0,1,8.507-2.9,8.616,8.616,0,0,1,10.523-5.8,11.979,11.979,0,0,1,22.629,2.44c.1,0,.194-.007.291-.007a7.241,7.241,0,0,1,7.181,6.324A3.878,3.878,0,0,1,924.221,1040.159Z",
    transform: "translate(-19770.025 -24763.352)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12055",
    "data-name": "Path 12055",
    d: "M2007.654,776.7h-56.216a3.875,3.875,0,0,1,3.769-2.979c.087,0,.176,0,.263.01a5.959,5.959,0,0,1,8.507-2.9,8.611,8.611,0,0,1,10.523-5.8,11.979,11.979,0,0,1,22.629,2.44c.1,0,.194-.007.291-.007a7.238,7.238,0,0,1,7.181,6.323A3.879,3.879,0,0,1,2007.654,776.7Z",
    transform: "translate(-20686.209 -24540.559)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12056",
    "data-name": "Path 12056",
    d: "M1388.233,431.481h-56.214a3.872,3.872,0,0,1,3.767-2.979c.088,0,.177,0,.264.01a5.958,5.958,0,0,1,8.507-2.9,8.614,8.614,0,0,1,10.523-5.8,11.979,11.979,0,0,1,22.628,2.44c.1,0,.194-.006.291-.006a7.241,7.241,0,0,1,7.182,6.322A3.878,3.878,0,0,1,1388.233,431.481Z",
    transform: "translate(-20162.406 -24248.635)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12058",
    "data-name": "Path 12058",
    d: "M1987.172,878.446c6.162,2.594,8.145-3.065,7.993-2.916a17.13,17.13,0,0,1,1.637-.841,7.667,7.667,0,0,0,3.9-7c3.544-2.209,3.326-5.828.9-8.406.747-2.869.264-8.816-2.593-8.509-3.724-6.633-10.474.276-10.37,9.661-3.038,1.289-4.478,4.361-3.789,7.811C1980.754,871.694,1980.886,875.806,1987.172,878.446Z",
    transform: "translate(-20712.105 -24616.799)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12059",
    "data-name": "Path 12059",
    d: "M2111.445,980.15l1.052-.275c-.02-.079-2.018-8.183-4.147-16.255-1.252-4.739-2.3-8.544-3.127-11.295-1.62-5.439-1.981-5.588-2.3-5.722l-.412,1.03a.339.339,0,0,1-.115-.079c.261.3,1.269,2.539,5.035,16.843C2109.51,972.291,2111.425,980.072,2111.445,980.15Z",
    transform: "translate(-20813.865 -24700.057)",
    fill: "#9c7357",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12060",
    "data-name": "Path 12060",
    d: "M1927.52,1024.994s.474-.378.622-.519c.171-.158.653-.684.653-.684s1.592-1.9,1.442-2.013-.6.071-.743.149-.312.166-.449.253a.315.315,0,0,1-.432-.118c-.117-.167.368-.622.567-.74a24.608,24.608,0,0,1,2.665-1.155c.229-.094,2.383-3.906,3.224-5.156h0c1.316-2.084,2.566-4.291,2.7-4.512l2.833-10.179,4.123-.409s-2.985,11.342-3.2,11.884c-.1.268-3.528,4.857-3.528,4.857-1.828,2.154-3.444,4.049-3.743,4.418,0,0-.6,1.359-.932,2.248a8.4,8.4,0,0,1-1.12,1.8,6.259,6.259,0,0,1-1.264,1.636c-.724.66-.338-.308-.338-.308s1.119-1.469.988-1.541c-.1-.055-.665.786-1.458,1.525-.2.189-.4.378-.59.551-.492.448-.905.267-.467-.283a6.26,6.26,0,0,1,.641-.707,5.633,5.633,0,0,0,.561-.708,7.645,7.645,0,0,0,.577-.731c-.034,0-.025-.134-.247.063-.267.236-.726.856-1.145,1.171-.238.18-.714.583-.714.583a5.534,5.534,0,0,1-.884.525c-.237-.211.249-.792.6-1a4.455,4.455,0,0,1,.672-.652s.851-1.061.7-1.187c-.12-.109-2.643,2.044-2.866,1.808C1926.79,1025.678,1927.52,1024.994,1927.52,1024.994Z",
    transform: "translate(-20665.496 -24745.135)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12061",
    "data-name": "Path 12061",
    d: "M1950.185,1141.84s-1.266.481-1.8-.172a.9.9,0,0,0,.669.573A1.753,1.753,0,0,0,1950.185,1141.84Z",
    transform: "translate(-20683.629 -24865.01)",
    fill: "#f27458",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12062",
    "data-name": "Path 12062",
    d: "M2004.989,1181.029l-2.334,21.591s1.14,4.566,1,5.862-2.538,18.307-2.538,18.307l.109.935.058,2.767-8.972.071a38.866,38.866,0,0,0,4.535-2.61,1.888,1.888,0,0,0,.757-1.352c.706-5.243-.692-22.732-.692-22.732l-1.1-22.77Z",
    transform: "translate(-20720.775 -24898.297)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12063",
    "data-name": "Path 12063",
    d: "M2066.478,1207.5c.5.132,1.277,18.667,1.695,19.484,2.641,5.2,3.269,21.034,3.269,21.034l1.092,2.215-.252,2.139s-1.972,1.17-3.355.377l.215-2.139.165-2.853-6.667-19.721-3.648-20.113Z",
    transform: "translate(-20777.16 -24920.684)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12064",
    "data-name": "Path 12064",
    d: "M1995.116,1102.955l-.316-12.78a25.3,25.3,0,0,1,2.538-10.376l3.023-5.258c.975.315,1.511-2.665,2.535-2.546.774.086,1.3.275,2.02.322,1.349.079,2.172,2.814,3.618,2.639.008.087.9.433.926.488.692,1.933,2.46,4,3.4,9.738a118.461,118.461,0,0,1,.931,18.471C2003.56,1104.118,2001.12,1104.488,1995.116,1102.955Z",
    transform: "translate(-20722.875 -24806.09)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12065",
    "data-name": "Path 12065",
    d: "M1998.02,1486.226h-9.262c-.343-.031-.426-.323-.307-.5.244-.369,1.325-.636,2.539-1.218,2.129.228,6.588-1.391,6.924-1.9A11.892,11.892,0,0,1,1998.02,1486.226Z",
    transform: "translate(-20717.467 -25153.318)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12066",
    "data-name": "Path 12066",
    d: "M2126.953,1484.28s-.824,2.421-1.713,2.35-1.668-1.972-1.668-1.972a8.841,8.841,0,0,0-.177,2.484,1.914,1.914,0,0,0,2.291,1.4A3.645,3.645,0,0,0,2126.953,1484.28Z",
    transform: "translate(-20831.588 -25154.732)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12067",
    "data-name": "Path 12067",
    d: "M2010.469,960.707a13.527,13.527,0,0,1-2.528-.613c-.742-.267-1.976-.849-1.976-.849s.694-6.021,2.438-9.668c.722-1.509,1.452-2.24,2.469-2.413Z",
    transform: "translate(-20732.32 -24700.529)",
    fill: "#142d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12068",
    "data-name": "Path 12068",
    d: "M2019.891,952.5c.261-.975.844-2.264,1.179-3.145.565-1.509.735-2.916,1.234-3.513.268-.322,3.724-.275,4.148-.322.177-.016.868.031,1.536.071h0a45.843,45.843,0,0,1,4.85.605c2.806,2.814,4.163,6.6,6.272,10.737,0,0-1.58.928-2.84,1.517-.547.251-1.6.66-1.6.66l-2.429-4.189c-.027-.024-.152-.157-.188-.071-.056.141-1.832,13.188-1.832,13.188s-7.2.606-8.884-.228c0,0-.313-8.708-.935-11.263C2020.174,955.6,2019.468,954.069,2019.891,952.5Z",
    transform: "translate(-20743.982 -24699.137)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12069",
    "data-name": "Path 12069",
    d: "M2051.866,911.381a25.487,25.487,0,0,0-.433,4.237c.109,1.195-.411,5.054-2.74,5.07s-.748-4.009-.527-5.188.575-5.706.575-5.706Z",
    transform: "translate(-20767.391 -24668.932)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12070",
    "data-name": "Path 12070",
    d: "M2054.979,911.523c.035-1,.14-1.729.14-1.729l3.125,1.587s-.11.621-.219,1.407A2.809,2.809,0,0,1,2054.979,911.523Z",
    transform: "translate(-20773.766 -24668.932)",
    fill: "#ed7d57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12071",
    "data-name": "Path 12071",
    d: "M2051.825,862.146a4.049,4.049,0,0,1,2.028,1.942c.714,1.462.948,5.549-1.93,7.121s-4.778-1.32-4.6-3.922S2048.3,861.282,2051.825,862.146Z",
    transform: "translate(-20767.281 -24628.523)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12072",
    "data-name": "Path 12072",
    d: "M2043.337,882.824c.181.653.609,1.093.959.983s.485-.723.3-1.376-.61-1.1-.958-.99S2043.156,882.173,2043.337,882.824Z",
    transform: "translate(-20763.855 -24644.938)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12073",
    "data-name": "Path 12073",
    d: "M2087.337,894.01c-.254.652-.127,1.336.281,1.532s.945-.181,1.2-.833.129-1.336-.28-1.533S2087.588,893.358,2087.337,894.01Z",
    transform: "translate(-20801.018 -24654.834)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12074",
    "data-name": "Path 12074",
    d: "M2093.711,1154.745v4.142a3.68,3.68,0,0,0,3.391,3.906h3.486v-9.667h-5.471a1.287,1.287,0,0,0-.968.447A1.729,1.729,0,0,0,2093.711,1154.745Z",
    transform: "translate(-20806.521 -24874.699)",
    fill: "#9c7357",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12075",
    "data-name": "Path 12075",
    d: "M2096.548,1153.573h.025a1.409,1.409,0,0,1,1.3,1.493v3.049c0,2.579,1.816,4.678,4.055,4.678h2.125c2.239,0,4.058-2.1,4.058-4.678v-3.033a1.846,1.846,0,0,0-1.7-1.956h-8.893A1.287,1.287,0,0,0,2096.548,1153.573Z",
    transform: "translate(-20808.916 -24874.699)",
    fill: "#e5bb9a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12076",
    "data-name": "Path 12076",
    d: "M2093.618,979.765l1.087-.009c0-.07-.037-7.765.067-15.609.06-4.605.155-8.363.282-11.16.219-4.779.486-5.636.56-5.777a4.959,4.959,0,0,0-.118-.857.629.629,0,0,0-.589.063c-.277.2-.452.565-.623,2.043-.106.92-.2,2.224-.284,3.875-.138,2.775-.239,6.563-.306,11.287C2093.583,971.655,2093.618,979.687,2093.618,979.765Z",
    transform: "translate(-20806.438 -24699.807)",
    fill: "#9c7357",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12077",
    "data-name": "Path 12077",
    d: "M2039.974,1036.119c-.137.025-1.094.079-1.094.079s-1.4-.84-1.6-.439c-.06.118,1.451.981,1.451.981s1.464.048,1.813.032a7.088,7.088,0,0,0,4.056-1.713c1.761-.9,10.611-6.06,10.741-7.042.077-.581-1.27-3.616-2.574-6.358-.576.322-1.469.809-2.243,1.179-.365.165-.957.4-1.306.542.846,1.635,1.647,3.317,1.543,3.663-.093.307-7.651,6.068-7.651,6.068l-1.51-.2s-2.663.323-2.723.637,1.122.235,1.28.283a1.47,1.47,0,0,1,.413.189,5.469,5.469,0,0,1-1.522.558,12.37,12.37,0,0,0-2.042.023c-.13.148,1.229.566,2.187.621.391.023.629-.094.8-.063.232.047-.177.236-.83.2-.374-.023-1.025-.228-1.436-.291a2.18,2.18,0,0,0-1.11.016,11.605,11.605,0,0,0,1.915.738s1.31.174,1.609.157C2040.141,1035.97,2040.323,1036.048,2039.974,1036.119Z",
    transform: "translate(-20758.236 -24763.525)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12084",
    "data-name": "Path 12084",
    d: "M2339,1148c-1.693,1.18-3.112,9.947-3.25,26.3-.18,6.135.885,14.264,2.262,24.946a9.879,9.879,0,0,0,4.028.481c1.746-13.258,2.033-21.725.731-25.2a97.71,97.71,0,0,0,4.19-13.233,105.073,105.073,0,0,0,2.659,14.96q3.4,8.859,10.073,23.2a6.811,6.811,0,0,0,3.922-.865c-1.555-11.7-4.529-20.492-7.328-23.4,2.663-14.954.446-22.741-2.859-27.31A44.144,44.144,0,0,1,2339,1148Z",
    transform: "translate(-21011.176 -24870.266)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12085",
    "data-name": "Path 12085",
    d: "M2207.441,990.777c4.412-17.1-.392-23.329-9.84-23.4a15.913,15.913,0,0,1-3.346,5.092,9.563,9.563,0,0,0-2.161-2.892,9.883,9.883,0,0,0-2.492,2.56,10.669,10.669,0,0,1,.5-4.587q-5.1.353-15.9,5.049a138.3,138.3,0,0,0-14.495-3.95l-.018.014.038.1a5.594,5.594,0,0,0-1.118,2.471l-.211-.054-.094.268c4.655,2.938,9.184,4.66,15.634,6.42,4.094-.033,8.233.128,12.4-1.336.061,12.3.926,17.411,2.622,18.825a30.933,30.933,0,0,0,5.941.531,5.972,5.972,0,0,1,.372,1.175c1.083-.336,2.274-.891,3.586-1.316l.361-.146A27.428,27.428,0,0,0,2207.441,990.777Z",
    transform: "translate(-20861.145 -24717.621)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12086",
    "data-name": "Path 12086",
    d: "M2317.591,1490.221c3.369.158,5.888.275,7.073-.018,1.279-.317,1.068-1.1.425-2.368a4.907,4.907,0,0,1-3.807-.315,9.449,9.449,0,0,1-4.738,1.4c-.905.585-.59,1.175,1.047,1.306Zm26.233.5a19.166,19.166,0,0,0,4.15-1.364c.9-.631.411-1.388-.5-2.343a4.912,4.912,0,0,1-3.734.8c-.991,1.407-4.212.816-4.529,1.78C2338.813,1491.39,2342.966,1490.964,2343.825,1490.722Z",
    transform: "translate(-20994.533 -25157.045)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12087",
    "data-name": "Path 12087",
    d: "M2369.408,1001.805c-.312-4.815-.693-10.676-1.074-17.946a3.369,3.369,0,0,0,.785-.612,7.526,7.526,0,0,0-1.214-1.344,7.759,7.759,0,0,0-1.435,1.247,3.52,3.52,0,0,0,.772.713q-.531,6.711-1.093,18.291a4.01,4.01,0,0,0,1.622,2A4.308,4.308,0,0,0,2369.408,1001.805Z",
    transform: "translate(-21036.904 -24729.908)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12088",
    "data-name": "Path 12088",
    d: "M2365.417,964.163a15.912,15.912,0,0,0,3.346-5.092,3.928,3.928,0,0,0-1.29-1.515,21,21,0,0,1-4.2,3.7l-.021.011c-.015-.052-.03-.1-.044-.157a27.564,27.564,0,0,1-.926-3.411,3.7,3.7,0,0,0-1.024,1.54,10.662,10.662,0,0,0-.5,4.587,13.726,13.726,0,0,1,1.059-1.314,7.843,7.843,0,0,1,1.434-1.246,7.615,7.615,0,0,1,1.215,1.344A12.515,12.515,0,0,1,2365.417,964.163Z",
    transform: "translate(-21032.307 -24709.32)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12089",
    "data-name": "Path 12089",
    d: "M2406.865,1028.165a3.147,3.147,0,0,0,.054-.923,11.556,11.556,0,0,1-4.255-.333,1.536,1.536,0,0,0-.177.815A12.072,12.072,0,0,0,2406.865,1028.165Z",
    transform: "translate(-21067.627 -24767.967)",
    fill: "#406fb5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12090",
    "data-name": "Path 12090",
    d: "M2360.2,903.981a4.589,4.589,0,0,1-.732-1.441c.1-.32.212-.725.325-1.214q3.066-2.181.782-3.147a4.05,4.05,0,0,0-1.1,1.6.927.927,0,0,1-.83-.534,27.564,27.564,0,0,0,.759-3.633c-1.056-1.5-3.451-1.664-6.61-1.185q-.192,1.269-.3,2.686c-.548.527-.435,2.438.128,4.631q-.344,1.888,2.366,2l.024.383a28.107,28.107,0,0,0,.927,3.41l.064.146A20.946,20.946,0,0,0,2360.2,903.981Z",
    transform: "translate(-21025.051 -24655.734)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12091",
    "data-name": "Path 12091",
    d: "M2346.778,874.709c3.158-.478,5.554-.313,6.609,1.185a27.547,27.547,0,0,1-.759,3.633.926.926,0,0,0,.83.534,4.052,4.052,0,0,1,1.1-1.6q2.284.967-.782,3.147-.17.733-.325,1.214a5.731,5.731,0,0,0,3.588-2.889c2.086-4.339-.382-6.1-1.7-6.732-.665-4.238-6.755-.349-9.891-2.331C2344.254,872.6,2345.82,874.691,2346.778,874.709Z",
    transform: "translate(-21019.031 -24636.016)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12092",
    "data-name": "Path 12092",
    d: "M2373,954.184a10.181,10.181,0,0,1-2.387.3l.024.383c.037.23.083.461.136.691l.022-.007A4.779,4.779,0,0,0,2373,954.184Z",
    transform: "translate(-21040.674 -24706.469)",
    fill: "#ed7d57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12093",
    "data-name": "Path 12093",
    d: "M2368.109,983.351a1.939,1.939,0,0,1-.211-.244,4.139,4.139,0,0,1,1.485-1.2,17.11,17.11,0,0,1,.765,1.662c.2-.157.337-.31.4-.362a7.689,7.689,0,0,0-1.164-1.3A7.5,7.5,0,0,0,2368.109,983.351Z",
    transform: "translate(-21038.379 -24729.908)",
    fill: "#223f81",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12094",
    "data-name": "Path 12094",
    d: "M2373.864,1478.664a4.657,4.657,0,0,1,.174,1.583,4.892,4.892,0,0,0,3.125-.613,6.54,6.54,0,0,1-.6-1.614,7.359,7.359,0,0,1-2.7.644Zm-19.01,1.647a10.237,10.237,0,0,1-.069-1.386,10.581,10.581,0,0,1-2.708-.277,3.325,3.325,0,0,1-.505,1.379A4.862,4.862,0,0,0,2354.853,1480.311Z",
    transform: "translate(-21024.572 -25149.439)",
    fill: "#fab688",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12095",
    "data-name": "Path 12095",
    d: "M2138.639,954.749q-.624-1.666-1.521-1.925a20.124,20.124,0,0,1-3.578-2.021q-.625.769,1,1.594a3.464,3.464,0,0,1,.982.741q-1.693.8-1.643,2.013.241.937.606,1.077a.509.509,0,0,0,.619-.142c.614,1.221,1.4,1.271,2.03,1.039.177.038.233.054.387.094A5.6,5.6,0,0,1,2138.639,954.749Z",
    transform: "translate(-20840.055 -24703.607)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12096",
    "data-name": "Path 12096",
    d: "M2344.408,1068.093l7.038,6.114c-1.859,1.232-4.243,2.874-7.625,5.224a4.209,4.209,0,0,1,.382.366c.088-.039.179-.076.269-.113.147.164.3.323.435.493a1.968,1.968,0,0,1,.358.721,2.253,2.253,0,0,1,.027.9c.022.09.044.179.068.269.872-.271,1.816-.683,2.834-1.055a34.014,34.014,0,0,0,7.063-3.5l1.734,1.506a.791.791,0,0,1,.079,1.111l-7.323,8.427a.789.789,0,0,1-1.11.078l-12.582-10.931a.789.789,0,0,1-.077-1.11l7.322-8.428A.786.786,0,0,1,2344.408,1068.093Z",
    transform: "translate(-21011.223 -24802.629)",
    fill: "#9c7357",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12097",
    "data-name": "Path 12097",
    d: "M2350.188,1065.386l7.794,5.849c-2.008,1.3-4.634,3.1-8.712,5.936a4.315,4.315,0,0,1,.382.366c.088-.039.179-.076.268-.113.148.164.3.324.436.493a1.952,1.952,0,0,1,.358.721,2.247,2.247,0,0,1,.027.9c.022.089.044.179.068.269.872-.271,1.814-.683,2.835-1.055a31.741,31.741,0,0,0,8.408-4.467l1.467,1.1a.789.789,0,0,1,.157,1.1l-6.7,8.928a.789.789,0,0,1-1.1.157l-13.33-10a.789.789,0,0,1-.157-1.1l6.7-8.929A.788.788,0,0,1,2350.188,1065.386Z",
    transform: "translate(-21016.676 -24800.371)",
    fill: "#bf9071",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12098",
    "data-name": "Path 12098",
    d: "M2334.379,972.879a21.208,21.208,0,0,1,1.219-1.817,2.016,2.016,0,0,1-.211-.244,13.626,13.626,0,0,0-1.056,1.31c.01.256.025.506.048.751Zm-3.311,3.65a26.865,26.865,0,0,1,.166-3.008,6.964,6.964,0,0,1-1.783,3.5q.808-.209,1.616-.49Zm7.914-4.065a12.545,12.545,0,0,0-.946-1.548c-.061.052-.2.2-.4.362.307.748.639,1.637.961,2.576a23.312,23.312,0,0,0,3.729-6.481,15.912,15.912,0,0,1-3.346,5.092Zm.65,23.422a5.143,5.143,0,0,0-1.166-1.466c4.753-3.3,7.532-5.2,9.661-6.542a37.216,37.216,0,0,1-1-10,25.981,25.981,0,0,0-.254,9.686c-3.7,2.559-7.144,5.226-9.391,7.091l.152.265a6.614,6.614,0,0,0-1,.835C2337.566,995.839,2338.57,995.882,2339.631,995.887Z",
    transform: "translate(-21005.869 -24717.621)",
    fill: "#406fb5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12099",
    "data-name": "Path 12099",
    d: "M2372.534,1144.228a18.256,18.256,0,0,0-2.8,1.422c-.761,1.278-.945,1.879-.587,2.591.794,1.005,2.062,1,2.178.279a.909.909,0,0,1,.147-1.291q.9.213,1.171-.451.367-.107.665-.185a2.063,2.063,0,0,0-.338-1.871C2372.832,1144.552,2372.68,1144.392,2372.534,1144.228Z",
    transform: "translate(-21039.289 -24867.176)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12107",
    "data-name": "Path 12107",
    d: "M1579.341,1033.026c-.251-.085-1.1-.283-2.081-.614a5.438,5.438,0,0,1-4-.365,2.924,2.924,0,0,1-.172-3.045,6.077,6.077,0,0,0,3.432.718q-1.836-1.21-.568-1.436a.973.973,0,0,0,.525.47,2.343,2.343,0,0,1,1.827,1.728c.454.122.924.234,1.164.309A3.922,3.922,0,0,0,1579.341,1033.026Z",
    transform: "translate(-20365.973 -24769.129)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12108",
    "data-name": "Path 12108",
    d: "M1756.311,872.415c3.15-.408,5.528-.193,6.544,1.319a26.9,26.9,0,0,1-.831,3.6.924.924,0,0,0,.814.549,4.024,4.024,0,0,1,1.124-1.566q2.25,1.009-.846,3.112-.181.724-.348,1.2a5.7,5.7,0,0,0,3.628-2.794c2.166-4.269-.249-6.072-1.541-6.73-.57-4.228-6.709-.491-9.785-2.529C1753.847,870.259,1755.358,872.377,1756.311,872.415Z",
    transform: "translate(-20519.766 -24634.07)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12109",
    "data-name": "Path 12109",
    d: "M1801.313,968.925a36.658,36.658,0,0,1-4.981,5.151q1.834-6.516,3.93-14.033a7.157,7.157,0,0,1,1.185,1.235q.166,3.048.081,4.652a6.344,6.344,0,0,1-1.749,1.077A7.062,7.062,0,0,1,1801.313,968.925Z",
    transform: "translate(-20555.047 -24711.424)",
    fill: "#142d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12110",
    "data-name": "Path 12110",
    d: "M1748.3,968.4a37.031,37.031,0,0,0,3.244,5.808q-.531-7.962-.538-13.418a5.123,5.123,0,0,0-1.236.905c-.056.067-.112.134-.164.2a40.651,40.651,0,0,0-1.1,4.769q.8.365,1.346.631Q1749.1,967.8,1748.3,968.4Z",
    transform: "translate(-20514.426 -24712.061)",
    fill: "#142d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12111",
    "data-name": "Path 12111",
    d: "M1800.4,968.044q4.579,2.655,7.486,4.7a68.614,68.614,0,0,1,2.128,16.162c-.179,6.651-.84,11.464-1.626,14.058a4.546,4.546,0,0,1-2.815-.5q-.374-8.776-.189-14.243a29.323,29.323,0,0,0-2.208-4.31c-.277,1.981-.659,3.7-.749,5.466a116.359,116.359,0,0,0,1.45,12.981q-1.81,1.737-8.007,2.07a170.594,170.594,0,0,1-.585-23.593,36.676,36.676,0,0,0,4.981-5.151,7.057,7.057,0,0,0-1.535-1.918,6.346,6.346,0,0,0,1.749-1.077Q1800.562,971.092,1800.4,968.044Z",
    transform: "translate(-20553.998 -24718.188)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12112",
    "data-name": "Path 12112",
    d: "M1732.042,980.272c-1.183,12.631-1.679,20.844-2.375,23.692a7.5,7.5,0,0,1-4.428-2.063c.248-7.187,1.086-11.777,1.441-15.977-.639-6.9-1.949-13.24-.538-16.188a10.066,10.066,0,0,1,3.961-1.775,40.788,40.788,0,0,0-1.1,4.769q.8.365,1.345.631-.747.5-1.548,1.1A37.091,37.091,0,0,0,1732.042,980.272Z",
    transform: "translate(-20494.928 -24718.117)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12113",
    "data-name": "Path 12113",
    d: "M1624.607,981.513q.848-1.04,1.789-2.052c-.977,2.043-.649,5.717-.142,10.076a32.5,32.5,0,0,1-4.928,4.767c-3.731.215-7.727-.651-13.888-2.516a4.624,4.624,0,0,1,.08-2.593c6,.346,9.668.288,12.074.908C1621.15,986.219,1623.127,983.916,1624.607,981.513Z",
    transform: "translate(-20395.184 -24727.844)",
    fill: "#142d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12114",
    "data-name": "Path 12114",
    d: "M1787.314,953.306a22.091,22.091,0,0,1,2.98-3.537,10.593,10.593,0,0,0-.3-1.087c-.056-.156-.392-.339-.841-.422.041.071.131.374.056.421-.017.012-.034.027-.051.042a17.118,17.118,0,0,1-3.522,2.228C1786.289,951.709,1786.74,952.5,1787.314,953.306Z",
    transform: "translate(-20546.004 -24701.457)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12115",
    "data-name": "Path 12115",
    d: "M1768.795,951.81a15.4,15.4,0,0,0,.069,2.281,3.258,3.258,0,0,1,1.235-1.669q.137-1.173.186-2.2A2.663,2.663,0,0,0,1768.795,951.81Z",
    transform: "translate(-20531.752 -24703.117)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12116",
    "data-name": "Path 12116",
    d: "M1760.436,987.533c.359-3.987.779-9.2,1.37-15.508q-.521-7.823-.538-13.228c.145-.054.3-.1.466-.146a15.2,15.2,0,0,0,.071,2.192,3.258,3.258,0,0,1,1.235-1.669,8.2,8.2,0,0,0,.543,1.19c.322-.336.628-.656.828-.9.6.727,1.041,1.489,1.591,2.255a22.6,22.6,0,0,1,2.948-3.511q.5.257.9.492-2.06,7.4-3.87,13.824a139.68,139.68,0,0,0,.029,15.175,13.818,13.818,0,0,1-1.486.146V987.8a.222.222,0,0,0-.216-.217l-2.087-.059a.205.205,0,0,0-.214.2v.038Q1761.234,987.681,1760.436,987.533Z",
    transform: "translate(-20524.691 -24709.869)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12117",
    "data-name": "Path 12117",
    d: "M1771.012,973.232a2.12,2.12,0,0,1,1.285-1.057,3.178,3.178,0,0,1,1.169,1.108,3.236,3.236,0,0,1-1.033,1.173,116.251,116.251,0,0,1,.948,17.982,8.843,8.843,0,0,1-1.523,2.48,6.671,6.671,0,0,1-1.118-2.745q.712-12.094.846-17.651A2.608,2.608,0,0,1,1771.012,973.232Z",
    transform: "translate(-20533.404 -24721.684)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12118",
    "data-name": "Path 12118",
    d: "M1774.163,966.314c.24.321.458.648.677.979-.2.133-.457.289-.771.466a3.743,3.743,0,0,0-.8-.821q.456-.338.89-.624Zm-1.972-.519a4.645,4.645,0,0,0,.469,1.1,2.163,2.163,0,0,0-.764.668,3.1,3.1,0,0,1-.329-1.052A3.225,3.225,0,0,1,1772.191,965.795Z",
    transform: "translate(-20534.104 -24716.285)",
    fill: "#406fb5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12119",
    "data-name": "Path 12119",
    d: "M1729.231,1189.459q-.04-9.7.653-22.83a11.2,11.2,0,0,0,3.408,1.225,41.37,41.37,0,0,0,1.117-6.981,11.575,11.575,0,0,0,1.2.256v.222a.22.22,0,0,0,.215.217l2.086.059a.207.207,0,0,0,.216-.2v-.158c.378-.017.759-.05,1.147-.1.216,3.3.3,5.513.47,7.129a27.868,27.868,0,0,0,7.143-1.493,180.733,180.733,0,0,1,1.407,21.069q2.1,4.513,1.152,22.048a10.453,10.453,0,0,1-4.064,0,181.374,181.374,0,0,1-3.116-20.76,161.37,161.37,0,0,1-3.859-17.32,134.886,134.886,0,0,1-2.167,17.123q.595,7.057-2.066,20.726a18.376,18.376,0,0,1-4.4-.4A161.021,161.021,0,0,0,1729.231,1189.459Z",
    transform: "translate(-20498.301 -24881.252)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12120",
    "data-name": "Path 12120",
    d: "M1743.334,1167.44c-.169-1.616-.254-3.827-.47-7.13.148-.018.3-.04.448-.063q.177,3.063.448,6.4a19.99,19.99,0,0,0,6.65-1.208c.024.17.045.342.068.512a27.878,27.878,0,0,1-7.143,1.493Zm-6.455-.44a11.2,11.2,0,0,1-3.408-1.225c.011-.194.021-.389.032-.585a7.65,7.65,0,0,0,3.125,1.053,53.888,53.888,0,0,0,.839-6.38c.177.057.353.108.53.156A41.373,41.373,0,0,1,1736.879,1167Z",
    transform: "translate(-20501.889 -24880.396)",
    fill: "#142d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12121",
    "data-name": "Path 12121",
    d: "M1718.608,1480.925c-.192.184-.255.132-.39.041-.221-1.208-2.5-1.349-3.064-.117a.62.62,0,0,1-.356-.314c-.4.781-1.3,1.546-1.058,2.909.6.871,3.722,1.3,5.2-.479.418-.677-.1-1.536-.33-2.041Zm-15.715-1.327c.382,1.032.466,1.881.016,2.215-1.145.23-3.493.2-7.109.677-2.554-.184-3.66-.91-3.014-1.718a9.01,9.01,0,0,0,6.01-1.735Q1699.3,1481.064,1702.893,1479.6Z",
    transform: "translate(-20467.334 -25150.297)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12122",
    "data-name": "Path 12122",
    d: "M1752.642,1475.557q.094,1.084.182,1.982c-.153.127-.216.076-.338-.005-.221-1.208-2.5-1.349-3.064-.117h-.012l0,0h-.008l0,0h-.012l0,0h0l0,0h0l0,0h0l0,0h-.017l0,0h0l0,0h0l0,0,0,0h-.007l0,0,0,0h0l0,0h0l-.009-.006,0,0h-.006v0h0l0,0h0l0,0h-.006l0,0h0l0,0h0l0,0h0v0h-.006l0,0,0,0h0l0,0v0l-.005,0h0l0,0h0l0,0h0l0,0,0,0h0c.1-.485.185-1.034.255-1.645a9.876,9.876,0,0,0,3.176-.093Zm-19.164-.58a3.235,3.235,0,0,1-.35.839c.014.035.027.07.042.1a1.4,1.4,0,0,0,.249.392v0c.033.035.069.07.105.1h0l.035.03.005,0a1.39,1.39,0,0,0,.447.236l0,0,.047.012.009,0a.38.38,0,0,0,.048.013l0,0,.05.012h0c.017,0,.035.007.052.011h.009l.05.009h.006a2.742,2.742,0,0,0,.568.023h.009l.061,0h.01l.061-.006h.013l.061-.008h.011l.068-.01h0l.071-.01.016,0c.17-.025.349-.061.54-.108l.021-.005.073-.02.01,0,.071-.02.023-.006.066-.018.024-.007.066-.02.029-.007.067-.022.02,0,.075-.024.02-.008.076-.024.018-.005.078-.027.02-.007.078-.027.1-.037c.061-.022.125-.045.188-.07l.015-.006.1-.038a7.717,7.717,0,0,1,.045-.893A19.964,19.964,0,0,1,1733.478,1474.977Z",
    transform: "translate(-20501.602 -25146.867)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12123",
    "data-name": "Path 12123",
    d: "M1626.614,999.582a48.536,48.536,0,0,0,.473,6.97,32.479,32.479,0,0,1-4.928,4.767c-3.731.215-7.727-.651-13.888-2.516a75.783,75.783,0,0,0,13.735,1.8,32.989,32.989,0,0,0,4.367-4.313A60.942,60.942,0,0,1,1626.614,999.582Z",
    transform: "translate(-20396.018 -24744.857)",
    fill: "#0e2952",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12124",
    "data-name": "Path 12124",
    d: "M1839.459,1067.272q.324-4.033.61-6.941a7.192,7.192,0,0,0,.624,1.627c-.277,1.981-.659,3.7-.749,5.466a116.193,116.193,0,0,0,1.45,12.981,3.526,3.526,0,0,1-.367.307A70.508,70.508,0,0,1,1839.459,1067.272Z",
    transform: "translate(-20591.516 -24796.23)",
    fill: "#0e2952",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12125",
    "data-name": "Path 12125",
    d: "M1765.2,1150.372a12.514,12.514,0,0,1-5.845-.384q.083-.855.167-1.8a16.676,16.676,0,0,0,5.57.165Q1765.141,1149.346,1765.2,1150.372Z",
    transform: "translate(-20523.779 -24870.521)",
    fill: "#9c7357",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12126",
    "data-name": "Path 12126",
    d: "M1772.891,1148.155l-2.087-.059a.207.207,0,0,0-.214.21v2.237a.223.223,0,0,0,.214.221l2.087.059a.209.209,0,0,0,.216-.21v-2.236A.224.224,0,0,0,1772.891,1148.155Z",
    transform: "translate(-20533.279 -24870.445)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12127",
    "data-name": "Path 12127",
    d: "M1774.955,1150.805v1.858l-1.688-.048v-1.857Z",
    transform: "translate(-20535.543 -24872.695)",
    fill: "#9c7357",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12128",
    "data-name": "Path 12128",
    d: "M1770.621,902.9c-.078.006-.164.008-.254.008l.076.068.178-.075Zm-.466,0c-.049,0-.1-.006-.147-.01l.127.076.02-.066Zm-1.914-1.584a17.259,17.259,0,0,1-3.379,2.194l-.248.12.084.1c-.175.214-.43.486-.708.774a1.768,1.768,0,0,1-.253-.091c-.189-.353-.255-.674-.411-.973.021-.175.039-.346.058-.516.019-.2.083-.933.115-1.132-.1-.007-.2-.016-.3-.026-.12-.016-.261-.039-.422-.069l-.006.006q-1.906-.36-1.578-1.953c-.513-2.191-.585-4.094-.028-4.606q.142-1.407.359-2.663c3.15-.409,5.528-.193,6.545,1.319a27.106,27.106,0,0,1-.831,3.6.921.921,0,0,0,.814.549,4.011,4.011,0,0,1,1.125-1.565q2.25,1.008-.846,3.111-.182.725-.348,1.2A4.089,4.089,0,0,0,1768.241,901.316Z",
    transform: "translate(-20524.977 -24654.137)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12129",
    "data-name": "Path 12129",
    d: "M1777.92,953.475a9.235,9.235,0,0,0,1.9-.058,7.211,7.211,0,0,1-1.988.947c.014-.13.025-.259.036-.386C1777.884,953.767,1777.905,953.565,1777.92,953.475Z",
    transform: "translate(-20539.4 -24705.822)",
    fill: "#ed7d57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12130",
    "data-name": "Path 12130",
    d: "M1807.6,1227.922l.855,19.844,21.648-2.279-2.563-17.566Z",
    transform: "translate(-20564.572 -24937.947)",
    fill: "#e5bb9a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12131",
    "data-name": "Path 12131",
    d: "M1789.762,1245.188a8.68,8.68,0,0,1,3.608,2.445l-.855-19.845-.974-.024Z",
    transform: "translate(-20549.49 -24937.818)",
    fill: "#9c7357",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12132",
    "data-name": "Path 12132",
    d: "M1807.6,1227.922l2.517,7.961c.363.883.735,1.655,2.2,1.534l13.892-.882c1.239-.078,1.27-.705,1.279-1.553v-7.061Z",
    transform: "translate(-20564.578 -24937.947)",
    fill: "#9c7357",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12133",
    "data-name": "Path 12133",
    d: "M1871,1279.018l3.533-.228a.4.4,0,0,1,.419.318l.481,3.137a.331.331,0,0,1-.285.392l-3.677.371a.385.385,0,0,1-.418-.316l-.337-3.282A.329.329,0,0,1,1871,1279.018Z",
    transform: "translate(-20617.947 -24980.965)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12134",
    "data-name": "Path 12134",
    d: "M1876.8,1284.86l.227,2.214,2.59-.261-.322-2.114Z",
    transform: "translate(-20623.094 -24985.959)",
    fill: "#9c7357",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12135",
    "data-name": "Path 12135",
    d: "M1834.5,1208.51a3.617,3.617,0,0,1,1.408-1.913,5.619,5.619,0,0,1,.975-.567c.21-.542,1.464-1,3-1.057,1.624-.062,2.972.344,3.1.92.1.044.2.091.3.141a3.652,3.652,0,0,1,2.028,2.476h-.748a3.008,3.008,0,0,0-1.607-1.838c-.106-.054-.213-.1-.324-.149a5.362,5.362,0,0,1-2.669.679,5.111,5.111,0,0,1-2.787-.521,4.821,4.821,0,0,0-.85.494,2.968,2.968,0,0,0-1.063,1.334Z",
    transform: "translate(-20587.326 -24918.535)",
    fill: "#9c7357",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12136",
    "data-name": "Path 12136",
    d: "M1857.157,1193.138c-.012.477-.183,1.2.121,1.54a3.222,3.222,0,0,0,3.59.385c.362-.249.4-1.061.412-1.582a9.4,9.4,0,0,1-.7-3.06,2.894,2.894,0,0,0-2.575-.328Z",
    transform: "translate(-20606.432 -24905.813)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12144",
    "data-name": "Path 12144",
    d: "M1429.561,879.389a3,3,0,0,1,.2,4.484s1.871.183,2.5-.335a1.7,1.7,0,0,1-.24.366,6.085,6.085,0,0,0,2.954-.577c.864-.653.31-11.351-5.493-10.155,0,0-4.92-.371-4.463,5.32s-1.4,5.692-1.4,5.692a2.655,2.655,0,0,0,.766.254s.365-.138.438-.34a1.309,1.309,0,0,1-.167.417,5.285,5.285,0,0,0,3.006-.567C1428.671,883.193,1429.844,880.563,1429.561,879.389Z",
    transform: "translate(-20239.875 -24637.885)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12145",
    "data-name": "Path 12145",
    d: "M1414.314,941.391h13.41c-.959-2.4-2.334-4.142-3.378-4.356-.554-.147-1.5-2.158-1.486-5.4l-.253.049-4.21.834s.094,1.326.1,2.575c0,1.041-.053,2.1-.29,2.223-.3.027-.579.083-.579.083A10.818,10.818,0,0,0,1414.314,941.391Z",
    transform: "translate(-20232.002 -24687.404)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12146",
    "data-name": "Path 12146",
    d: "M1440.763,932.791s.094,1.326.1,2.575c2.359-.067,3.6-2.217,4.113-3.409Z",
    transform: "translate(-20254.369 -24687.674)",
    fill: "#ed7d57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12147",
    "data-name": "Path 12147",
    d: "M1430.875,881.581a12.4,12.4,0,0,0,1.532-3.62c.212-1.192-.394-5.608-4.833-4.972a6.017,6.017,0,0,0-2.5.946c-.965.651-2.356,2.055-.8,5.909l.4,1.3Z",
    transform: "translate(-20239.834 -24637.756)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12148",
    "data-name": "Path 12148",
    d: "M1425.489,893.478s5.574.091,5.578-3.382.726-5.8-2.833-6.006-4.252,1.119-4.537,2.278S1424.038,893.365,1425.489,893.478Z",
    transform: "translate(-20239.881 -24647.176)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12149",
    "data-name": "Path 12149",
    d: "M1437.005,879.787s1.526,4.075,3.871,4.677,3.358-.024,3.358-.024a6.639,6.639,0,0,1-2.169-3.92S1438.157,877.847,1437.005,879.787Z",
    transform: "translate(-20251.189 -24642.955)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12150",
    "data-name": "Path 12150",
    d: "M1423.984,882.157a4.929,4.929,0,0,0-1.418,1.794c-.279.884-.405,2.706-.934,2.644,0,0-1.152-2.77.141-4.337C1423.145,880.6,1423.984,882.157,1423.984,882.157Z",
    transform: "translate(-20237.791 -24644.998)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12151",
    "data-name": "Path 12151",
    d: "M1438.069,880.611s1.089,4.267,4.047,5.634c0,0-2.957-2.622-3.208-5.439S1438.069,880.611,1438.069,880.611Z",
    transform: "translate(-20252.088 -24643.313)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12152",
    "data-name": "Path 12152",
    d: "M1302.332,1051.569s-1.859-1.52-2.528-1.528-1.937-.34-1.887-.124,1.12.5.936.6-1.736-.318-2.171-.068-1.453,1.286-.634,1.737a11.817,11.817,0,0,0,3.907,1.086c.634-.084,2.07-.184,2.07-.184Z",
    transform: "translate(-20131.729 -24787.361)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12153",
    "data-name": "Path 12153",
    d: "M1470.463,1427.043l-1.559,6.569-2.336-.015-.086-6.554Z",
    transform: "translate(-20276.117 -25106.332)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12154",
    "data-name": "Path 12154",
    d: "M1331.223,1424.126l-4.437,6.288-1.729-2.221,2.67-4.931Z",
    transform: "translate(-20156.523 -25103.135)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12155",
    "data-name": "Path 12155",
    d: "M1329.618,1173.217l2.284.07,2.474.076a48.837,48.837,0,0,0,8.918-16.556c.074-.237.153-.477.237-.72,1.753-5.113,5.389-11.532,7.3-17.341.305-.926.578-1.8.824-2.621.078-.263.156-.524.228-.779a61.594,61.594,0,0,0,2.2-11.568l-13.834.112A257.915,257.915,0,0,1,1329.618,1173.217Z",
    transform: "translate(-20160.381 -24849.881)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12156",
    "data-name": "Path 12156",
    d: "M1400.058,974.791c.036,6.581-.965,9.407-.965,9.407a18.584,18.584,0,0,0,12.963.794c.083-.026,5.829-1.338,5.829-1.338-.118-.266-1.165-4.7-1.281-4.948-1.486-3.19-2.615-4.591-2.791-5.572a20.842,20.842,0,0,1-.171-5.515,44.281,44.281,0,0,1,1.706-8.661,45.008,45.008,0,0,1-5.711-1.952,4.459,4.459,0,0,1-3.081,1.143c-1.4-.031-1.857-.631-1.785-1.287-1.494.832-2.686,1.617-2.686,1.617-1.271,2.206-3.846,4.348-4.033,7.733C1398.007,967.043,1400.058,974.605,1400.058,974.791Z",
    transform: "translate(-20218.25 -24708.734)",
    fill: "#e9f0f9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12157",
    "data-name": "Path 12157",
    d: "M1466.127,1467.214a6.329,6.329,0,0,0,.3,2.692s.382,1.743-1.333,1.775-2.137-.13-1.942-1.2.563-2.917.563-2.917Z",
    transform: "translate(-20273.264 -25140.305)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12158",
    "data-name": "Path 12158",
    d: "M1461.919,1487.214c1.09,2.057,2.645,1.909,3.757,0a9.992,9.992,0,0,0-.242-2.739c-.005-.023-.009-.04-.011-.053s0-.017,0-.017c-1.942,1.78-3.157-.047-3.157-.047s0,.006,0,.01A11.426,11.426,0,0,0,1461.919,1487.214Z",
    transform: "translate(-20272.258 -25154.801)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12159",
    "data-name": "Path 12159",
    d: "M1298.269,1460.506a42.951,42.951,0,0,0,4.133-5.3l2.351,1.205-5.255,4.935-1.231-.161Z",
    transform: "translate(-20133.869 -25130.15)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12160",
    "data-name": "Path 12160",
    d: "M1285.269,1469.169h3.979c.586,0,1.053-.971,1.685-2.235a2.121,2.121,0,0,1,1.431-.957l-.016,3.192h.92l.844-3.374c.562-1.03.046-1.964-.349-2.776-.458,0-1.691.313-4.028,2.943a3.064,3.064,0,0,1-2.457,1.148c-.012.007-.025.012-.036.019C1285.3,1468,1285.269,1469.169,1285.269,1469.169Z",
    transform: "translate(-20122.877 -25136.756)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12161",
    "data-name": "Path 12161",
    d: "M1344.412,1228.191l2.474.076a48.839,48.839,0,0,0,8.918-16.556c.074-.237.153-.477.237-.72,1.753-5.113,5.389-11.533,7.3-17.341.305-.926.578-1.8.824-2.621.079-.264.156-.524.228-.779l-2.037-1.546s-6.117,9.905-8.01,19.225C1352.705,1216.026,1346.118,1225.768,1344.412,1228.191Z",
    transform: "translate(-20172.889 -24904.787)",
    fill: "#406fb5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12162",
    "data-name": "Path 12162",
    d: "M1451.856,1194.392c-.036,4.533.194,14.954.783,19.268h2.191c1.212,0,1.815-.016,1.815-.016,1.482-7.5,2.534-13.708,3.3-19.057.629-4.39,1.188-8.152,1.619-11.39.433-3.26.733-5.99.841-8.3.017-.363.03-.718.037-1.06s.007-.679,0-1.006l-11.953-1.165C1450.647,1179.613,1451.876,1191.759,1451.856,1194.392Z",
    transform: "translate(-20262.598 -24890.383)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12163",
    "data-name": "Path 12163",
    d: "M1478.574,1231.357c1.212,0,1.815-.016,1.815-.016,1.482-7.5,2.534-13.708,3.3-19.057.629-4.39,1.189-8.152,1.619-11.39.433-3.26.733-5.99.841-8.3l-4.386,2.58s2.8.987,1.732,8.463S1480.06,1230.3,1478.574,1231.357Z",
    transform: "translate(-20286.34 -24908.078)",
    fill: "#406fb5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12164",
    "data-name": "Path 12164",
    d: "M1452.545,994.087s.841,3.043,3.755,2.655a35.2,35.2,0,0,0,7.055-2.137s-1.243-3.935-2.793-9.1c-1.874-6.258-2.34-15.05-3.433-20.138-.307-1.425-2.371-1.888-2.448-2.741l-2.416-4.689s-3.6,8.087-3.8,10.127S1452.545,994.087,1452.545,994.087Z",
    transform: "translate(-20260.877 -24709.643)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12165",
    "data-name": "Path 12165",
    d: "M1488.086,1029.835c.13,3.3,1.285,8.934,5.925,11.409.018.01.037.017.055.027-1.874-6.258-1.849-12.259-2.942-17.347C1488.63,1023.4,1488.016,1028.017,1488.086,1029.835Z",
    transform: "translate(-20294.383 -24765.406)",
    fill: "#142d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12166",
    "data-name": "Path 12166",
    d: "M1503.612,1109.033s-2.081-.45-2.616.143-.835,1.539-.3,1.87,2.083-.579,2.639-.212c.4.264.524.933.925.7s.822-1.767.822-1.767Z",
    transform: "translate(-20304.811 -24837.271)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12167",
    "data-name": "Path 12167",
    d: "M1473.107,957.938s5.616.247,6.965,1.5,9.433,10.939,9.565,13.478-7.079,9.754-7.079,9.754a5.567,5.567,0,0,1-2.872-1.745s4.474-7.98,4.207-8.328-7.848-6.561-8.469-5.183C1474.888,968.6,1473.107,957.938,1473.107,957.938Z",
    transform: "translate(-20281.717 -24709.643)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12168",
    "data-name": "Path 12168",
    d: "M1330.614,972.116s6.412,2.138,7.214,1.959,1.947-8.866,2.565-11.845a5.759,5.759,0,0,1,3.836-4.6l2.883-.772s-3.3,8.157-3.4,9.808-.389,26.995-.389,26.995.2,1.165-2.038.679a7.5,7.5,0,0,1-2.816-.972s.968-7.084,1.423-13.373c-2.275-.39-9.591-4.1-9.591-4.1C1329.167,974.118,1330.614,972.116,1330.614,972.116Z",
    transform: "translate(-20160.59 -24708.734)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12176",
    "data-name": "Path 12176",
    d: "M445.156,1416.1s-2.916,2.7-2.349,4.621,3.2,3.2,3.557,5.548,1.778,3.628,3.058,3.628h6.1s.942-1.652-1.335-2.15-3.134-3.256-2.991-5.816a45.915,45.915,0,0,0-.212-5.973l-4.836-1.138Z",
    transform: "translate(-19410.402 -25095.998)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12177",
    "data-name": "Path 12177",
    d: "M689.649,1462.715a11.217,11.217,0,0,0,2.762.32h13.8c-.046-.411-.367-1.875-2.625-2.239-2.55-.414-6.968-1.9-7.951-5.159-.033-.1-.061-.211-.087-.319-.78-3.484-6.469,1.067-6.469,1.067s-.017.14-.043.375C688.906,1458.042,688.569,1462.177,689.649,1462.715Z",
    transform: "translate(-19618.557 -25129.131)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12178",
    "data-name": "Path 12178",
    d: "M647.509,898.416s-.865,10.782-1.881,23.742c-1.378,17.6-3.038,39.228-3.2,43.326C642.141,972.6,641,983.974,641,983.974s-2.7,2.706-8.109,1.565A186.227,186.227,0,0,1,626.7,952.11c-.021-.282-.042-.567-.063-.849-1.28-17.5-3.27-54.339-3.27-54.339Z",
    transform: "translate(-19563.146 -24658.049)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12179",
    "data-name": "Path 12179",
    d: "M647.509,898.416s-.865,10.782-1.881,23.742L626.7,952.11c-.021-.282-.042-.567-.063-.849-1.28-17.5-3.27-54.339-3.27-54.339Z",
    transform: "translate(-19563.146 -24658.049)",
    fill: "#142d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12180",
    "data-name": "Path 12180",
    d: "M504.082,876.333s-15.576,39.047-25.815,57.395S464.824,957.2,464.824,957.2s-5.866-2.346-6.4-3.945c0,0,3.915-35.426,10.775-44.059,3.876-4.88,8.428-19.523,8.64-24.644s1.386-15.255,1.386-15.255Z",
    transform: "translate(-19423.67 -24634.68)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12181",
    "data-name": "Path 12181",
    d: "M1059.332,744.486a46.723,46.723,0,0,1,4.935-.919,10.179,10.179,0,0,1,3.23,1.29c.033.2-.083.367-.514.4s-1.843-.152-1.755.019,4.165.972,4.209,1.792-2.186,2.344-4.072,2.447-5.6-2.09-5.913-2.118C1056.757,747.157,1059.332,744.486,1059.332,744.486Z",
    transform: "translate(-19930.879 -24528.361)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12182",
    "data-name": "Path 12182",
    d: "M772.417,580.031c.6-1.931.462-2.239.462-2.239s-17.124-9.258-18.693-10.2-19.267-19.773-19.267-19.773l-18.127,4.989s28.055,21.371,32.073,23.67c6.644,3.8,22.03,5.955,22.03,5.955A5.653,5.653,0,0,0,772.417,580.031Z",
    transform: "translate(-19642.152 -24362.836)",
    fill: "#406fb5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12183",
    "data-name": "Path 12183",
    d: "M798.651,470.534s6.354,11.182,12.567,12.641a16.969,16.969,0,0,0-1.772-6.326c.621-.73,1.165-1.4,1.635-2a37.423,37.423,0,0,0,2.307-3.23l-2.108-5.667-1.432-3.846a18.625,18.625,0,0,1-2.233,3.222A15.213,15.213,0,0,1,798.651,470.534Z",
    transform: "translate(-19711.375 -24290.35)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12184",
    "data-name": "Path 12184",
    d: "M856.423,482.968a11.784,11.784,0,0,0,3.466,9.52,37.435,37.435,0,0,0,2.307-3.23l-2.108-5.667A12.018,12.018,0,0,0,856.423,482.968Z",
    transform: "translate(-19760.186 -24307.99)",
    fill: "#ed985f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12185",
    "data-name": "Path 12185",
    d: "M863.944,428.758s-9.5-3.7-7.1-9.578,2.787-10.315,8.95-8.2,6.421,4.835,6.1,6.99S866.476,429.57,863.944,428.758Z",
    transform: "translate(-19760.258 -24246.664)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12186",
    "data-name": "Path 12186",
    d: "M584.735,565.489c3.832,5.508,32.47,12.866,32.131,9.055a41.218,41.218,0,0,1,0-7.519q.1-1.227.3-2.6a59.909,59.909,0,0,1,6.311-18.9c.29-.558.589-1.121.9-1.693a58.309,58.309,0,0,0,3.97-8.921c1.985-5.734,2.784-11.22,1.781-14.807a.36.36,0,0,0-.013-.05c-5.985-2.768-8.306-13.5-8.306-13.5s-16.748-1.292-24.188,27.851C597.631,534.4,581.4,560.7,584.735,565.489Z",
    transform: "translate(-19530.102 -24327.926)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12187",
    "data-name": "Path 12187",
    d: "M770.558,693.42q.1-1.227.3-2.6a59.868,59.868,0,0,1,6.31-18.9c-.662-4.013-1.575-7.349-2.578-8.85-4.074-6.105-6.446-7.059-6.446-7.059S762.039,681.77,770.558,693.42Z",
    transform: "translate(-19683.791 -24454.322)",
    fill: "#406fb5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12188",
    "data-name": "Path 12188",
    d: "M764.367,592.4c1.131-1.828.315-2.662.315-2.662s-17.452-13.666-18.822-15.045-7.7-23.363-7.7-23.363-2.182-8.9-7.289-9.878c-4.439-.853-7.5,1.343-9.513,3.917a9.466,9.466,0,0,0-.643,10.645c4.457,7.509,13.446,22.413,16.071,24.961,5.843,5.668,25.392,13.587,25.392,13.587A6.739,6.739,0,0,0,764.367,592.4Z",
    transform: "translate(-19644.342 -24357.297)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12189",
    "data-name": "Path 12189",
    d: "M843.64,383.711a16.7,16.7,0,0,1,11.274,2.76c1.71,1.087,2.542,2.14,4.2,1.743,4.944-1.187,3.64,6.735-2.763,6.941-1.54.473-4.375-2.56-6.924-2.973s-3.928,3.137-4.9,3.429-.418-.512-1.435-1.32-1.6,1.092-1.58,2.43-1.964,2.6-1.964,2.6l-1.164-2.133C834.955,392.772,837.787,384.523,843.64,383.711Z",
    transform: "translate(-19743.723 -24223.941)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12196",
    "data-name": "Path 12196",
    d: "M1039.894,686.145h0a2,2,0,0,1,1.119,2.6l-15.229,38.286a2.006,2.006,0,0,1-2.6,1.119h0a2,2,0,0,1-1.119-2.6l15.231-38.286A2,2,0,0,1,1039.894,686.145Z",
    transform: "translate(-19900.184 -24479.688)",
    fill: "#cbd5eb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12197",
    "data-name": "Path 12197",
    d: "M1118.716,417.78c7.421,2.952,9.49,15.266,4.621,27.506s-14.831,19.768-22.252,16.817-9.489-15.267-4.62-27.506S1111.3,414.828,1118.716,417.78Z",
    transform: "translate(-19960.986 -24252.326)",
    fill: "#cbd5eb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12198",
    "data-name": "Path 12198",
    d: "M1130.151,436.32c6.521,2.594,8.339,13.418,4.06,24.175s-13.035,17.375-19.556,14.781-8.34-13.418-4.061-24.175S1123.629,433.725,1130.151,436.32Z",
    transform: "translate(-19973.205 -24268.072)",
    fill: "#e9eef7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12199",
    "data-name": "Path 12199",
    d: "M1080.493,428.5c4.64-11.664,13.906-19.05,21.189-17.164l-.875-.348-1.13-.416a11.1,11.1,0,0,0-1.061-.347c-7.284-1.887-16.431,5.438-21.071,17.1-3.033,7.624-5.057,21.982,3.6,26.942l2.082.91.879.35C1077.514,451.9,1075.852,440.164,1080.493,428.5Z",
    transform: "translate(-19945.018 -24246.23)",
    fill: "#8ca3ca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12200",
    "data-name": "Path 12200",
    d: "M1159.763,437.562c5.851,3.146,7.34,13.5,3.244,23.795s-12.288,16.8-18.7,15.064a7.7,7.7,0,0,0,.816.38c6.521,2.595,15.278-4.023,19.556-14.78s2.462-21.581-4.06-24.175A8.09,8.09,0,0,0,1159.763,437.562Z",
    transform: "translate(-20003.672 -24269.598)",
    fill: "#8ca3ca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12201",
    "data-name": "Path 12201",
    d: "M1024.069,735.853l14.371-36.126-.047-.018-1.4-.612-14.926,37.525a2,2,0,0,0,3.239,2.185A2.3,2.3,0,0,1,1024.069,735.853Z",
    transform: "translate(-19900.184 -24490.762)",
    fill: "#8ca3ca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12202",
    "data-name": "Path 12202",
    d: "M992.115,858.647a60.9,60.9,0,0,1,6.526.611,13.316,13.316,0,0,1,3.6,2.776c-.029.264-.238.427-.787.311s-2.259-.851-2.21-.6,4.881,2.709,4.646,3.754-3.585,2.162-5.99,1.617-6.278-4.622-6.669-4.77C987.927,861.082,992.115,858.647,992.115,858.647Z",
    transform: "translate(-19873.152 -24625.678)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12203",
    "data-name": "Path 12203",
    d: "M1146.977,456.219a.569.569,0,1,1-1.084.344,3.234,3.234,0,0,0-1.369-1.862,4.164,4.164,0,0,0-3.142-.3,11.285,11.285,0,0,0-4.192,2.156,24.786,24.786,0,0,0-8.112,13.114.571.571,0,0,1-1.1-.3,25.926,25.926,0,0,1,8.516-13.714,12.437,12.437,0,0,1,4.631-2.368,5.259,5.259,0,0,1,3.991.436,4.347,4.347,0,0,1,1.864,2.491Zm-19.733,16.43a.571.571,0,0,1,1.113.26,16.959,16.959,0,0,0-.265,1.772c-.076.708-.128,1.426-.128,1.884a.569.569,0,1,1-1.138,0c0-.508.053-1.269.131-2A18.43,18.43,0,0,1,1127.244,472.648Z",
    transform: "translate(-19988.893 -24282.73)",
    fill: "#cbd5eb",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpSlient1);
export default __webpack_public_path__ + "static/media/sign-up-slient1.b1a20a33dae4c884663e5cb4db5e2fd0.svg";
export { ForwardRef as ReactComponent };